export default defineNuxtPlugin(() => {
  const { user } = useAuth()

  const bugsnag = useBugsnag()

  bugsnag.addOnError((event) => {
    // add user information to the error
    if (user.value)
      event.setUser(user.value.id, user.value.email)
  })
})
